import {useDispatch} from 'react-redux';
import ICON_LIKE_OFF from '../../../../public/static/v4/myPage/icon-alarm-off.svg';
import ICON_LIKE_ON from '../../../../public/static/v4/myPage/icon-alarm-on.svg';
import ContentCardWrapperV4 from '../../../common/component/ContentCardWrapperV4';
import FetchResultWrapper from '../../../common/component/FetchResultWrapper';
import useLogin from '../../../common/hook/useLogin';
import {sendHomeEvent} from '../../common/tracking';
import MyContentCardV4 from '../component/MyContentCardV4';
import ToggleWithContentV4 from '../component/ToggleWithContentV4';
import {actions} from '../state/action';
import {IClickContentProps, IEditPropsV4, ILikeV4} from '../type';

interface IProps extends IEditPropsV4, IClickContentProps {
  like?: ILikeV4;
}

export default function LikeTabV4({
  like,
  isEdit,
  showLoading,
  selectedList = {},
  onToggle,
  onClickContent,
}: IProps) {
  const {isLogin} = useLogin();
  const dispatch = useDispatch();

  const handleClickLike = ({
    id,
    isLike,
    index,
  }: {
    id: number;
    isLike: boolean;
    index: number;
  }) => {
    sendHomeEvent({
      actionName: 'content_alarm',
      action: 'click',
      customProps: {
        content_id: id,
        ordnum: index + 1,
        is_alarm_on: isLike ? 'N' : 'Y',
      },
    });
    isEdit
      ? onToggle?.(id)
      : dispatch(actions.fetchLikeAlarmToggle(id, !isLike));
  };

  return (
    <FetchResultWrapper
      showLoading={!like || showLoading}
      showNoLogin={!isLogin}
      showNoItems={!!like && like.contents.length === 0}
      noLoginProps={{
        textKey: 'library_tab_favorites_before_login',
      }}
      noItemsProps={{
        textKey: 'library_tab_empty',
      }}
    >
      <ContentCardWrapperV4>
        {(like?.contents || []).map(({content, isLike}, index) => (
          <MyContentCardV4
            key={content.id}
            content={isEdit ? {...content, badges: []} : content}
            isDimmed={selectedList[content.id]}
            onClick={
              onClickContent ? () => onClickContent(content, index) : onToggle
            }
            onClickBottom={() =>
              handleClickLike({id: content.id, isLike, index})
            }
          >
            <ToggleWithContentV4
              toggleType="checkbox"
              showToggle={isEdit}
              isSelected={selectedList[content.id]}
            >
              <img src={ICON_MAP[isLike ? 'on' : 'off']} alt="" />
            </ToggleWithContentV4>
          </MyContentCardV4>
        ))}
      </ContentCardWrapperV4>
    </FetchResultWrapper>
  );
}

const ICON_MAP = {
  on: ICON_LIKE_ON,
  off: ICON_LIKE_OFF,
};
